import { gql } from '@src/__generated__';

export const GET_TRIP_PROFILES = gql(`
  query TripProfiles($clientId: ID!) {
    clientTripProfiles(clientId: $clientId) {
      clientId
      id
      title
      status
      startDate
      endDate
      destination
      country
      travelPartyType
      numberTravelers
      budgetLower
      budgetUpper
      occasionType
      accommodationType
      scheduleDensity
      supportLevel
      culturalComfortLevel
    }
  }
`);

export const GET_TRIP_PROFILE = gql(`
  query TripProfile($id: ID!) {
    singleTripProfile(id: $id) {
      clientId
      id
      title
      country
      destinationId
      destination
      destinationLat
      destinationLong
      status
      startDate
      endDate
    }
  }
`);
export const GET_TRIP_PROFILE_DETAILS = gql(`
  query TripProfileDetails($id: ID!) {
    singleTripProfile(id: $id) {
      clientId
      id
      title
      country
      destinationId
      destination
      destinationLat
      destinationLong
      status
      startDate
      endDate
      travelPartyType
      numberTravelers
      budgetLower
      budgetUpper
      accommodationType
      occasionType
      scheduleDensity
      culturalComfortLevel
      supportLevel
    }
  }
`);

export const GET_LAST_STEP = gql(`
  query LastStep($id: ID!) {
    singleTripProfile(id: $id) {
      id
      lastStep
    }
  }
`);

export const UPDATE_TRIP_PROFILE_DESTINATION = gql(`
  mutation UpdateTripProfile(
    $tripProfile: TripProfileInput!
  ) {
    updateClientTripProfile(
      tripProfile: $tripProfile
    ) {
      id
      clientId
      title
      status
      destinationId
      destination
      country
      startDate
      endDate
      travelPartyType
      numberTravelers
      budgetLower
      budgetUpper
      accommodationType
      occasionType
      scheduleDensity
      culturalComfortLevel
      supportLevel
    }
  }
`);

export const UPSERT_TRIP_PROFILE_DETAILS = gql(`
  mutation UpsertTripProfile(
    $id: ID
    $clientId: ID!
    $title: String
    $status: TripProfileStatus
    $destinationId: ID
    $destination: String
    $country: String
    $startDate: String
    $endDate: String
    $travelPartyType: TravelPartyType
    $numberTravelers: Int
    $budgetLower: Int
    $budgetUpper: Int
    $accommodationType: AccommodationType
    $occasionType: OccasionType
    $scheduleDensity: ScheduleDensity
    $culturalComfortLevel: CulturalComfortLevel
    $supportLevel: SupportLevel
  ) {
    upsertClientTripProfile(
      id: $id
      clientId: $clientId
      title: $title
      status: $status
      destinationId: $destinationId
      destination: $destination
      country: $country
      startDate: $startDate
      endDate: $endDate
      travelPartyType: $travelPartyType
      numberTravelers: $numberTravelers
      budgetLower: $budgetLower
      budgetUpper: $budgetUpper
      accommodationType: $accommodationType
      occasionType: $occasionType
      scheduleDensity: $scheduleDensity
      culturalComfortLevel: $culturalComfortLevel
      supportLevel: $supportLevel
    ) {
      id
      clientId
      title
      status
      destinationId
      destination
      country
      startDate
      endDate
      travelPartyType
      numberTravelers
      budgetLower
      budgetUpper
      accommodationType
      occasionType
      scheduleDensity
      culturalComfortLevel
      supportLevel
    }
  }
`);

export const GET_TRIP_PROFILE_STATE = gql(`
  query TripProfileQuestionStates($tripProfileId: ID!) {
    findQuestionStates(tripProfileId: $tripProfileId) {
      id
      tripProfileId
      questionId
      parentQuestionId
      questionType
	    rank
    }
  }
`);
